import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShareLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-.3 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M1.64063 5.84375C1.22569 5.84375 1.03125 6.11635 1.03125 6.29062V13.9906C1.03125 14.1649 1.22569 14.4375 1.64063 14.4375H11.7656C12.1806 14.4375 12.375 14.1649 12.375 13.9906V6.29062C12.375 6.11635 12.1806 5.84375 11.7656 5.84375H10.8281C10.5434 5.84375 10.3125 5.6129 10.3125 5.32812C10.3125 5.04335 10.5434 4.8125 10.8281 4.8125H11.7656C12.5933 4.8125 13.4062 5.40175 13.4062 6.29062V13.9906C13.4062 14.8795 12.5933 15.4688 11.7656 15.4688H1.64063C0.812923 15.4688 0 14.8795 0 13.9906V6.29062C0 5.40175 0.812923 4.8125 1.64063 4.8125H2.57812C2.8629 4.8125 3.09375 5.04335 3.09375 5.32812C3.09375 5.6129 2.8629 5.84375 2.57812 5.84375H1.64063Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M6.70312 0C6.9879 0 7.21875 0.230853 7.21875 0.515625V8.07812C7.21875 8.3629 6.9879 8.59375 6.70312 8.59375C6.41835 8.59375 6.1875 8.3629 6.1875 8.07812V0.515625C6.1875 0.230853 6.41835 0 6.70312 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M6.33852 0.151023C6.53989 -0.050341 6.86636 -0.050341 7.06773 0.151023L9.81773 2.90102C10.0191 3.10239 10.0191 3.42886 9.81773 3.63023C9.61636 3.83159 9.28989 3.83159 9.08852 3.63023L6.70312 1.24483L4.31773 3.63023C4.11636 3.83159 3.78989 3.83159 3.58852 3.63023C3.38716 3.42886 3.38716 3.10239 3.58852 2.90102L6.33852 0.151023Z"
		})
	]
});
export { SvgShareLink as ReactComponent };
